"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'jita/app/v1';

var JitaAPI =
/*#__PURE__*/
function () {
  function JitaAPI() {
    (0, _classCallCheck2.default)(this, JitaAPI);
  }

  (0, _createClass2.default)(JitaAPI, null, [{
    key: "fetchJitaEnabled",
    value: function fetchJitaEnabled() {
      return _apiClient.default.get(API_BASE + "/status");
    }
  }, {
    key: "setJitaEnabled",
    value: function setJitaEnabled() {
      return _apiClient.default.post(API_BASE + "/status/enable");
    }
  }, {
    key: "setJitaDisabled",
    value: function setJitaDisabled() {
      return _apiClient.default.post(API_BASE + "/status/disable");
    }
  }]);
  return JitaAPI;
}();

exports.default = JitaAPI;
module.exports = exports.default;